module.exports = "/assets/archetype-fears.webp"